import { analyticsTrackEvent } from '@core/utils/analytics';
import { PARTICIPANT_HISTORY_OPENED } from '@core/constants/analytics';

const ITEM_TYPE = 'Participants';

export const trackParticipantHistoryOpened = (spaceId: string) => {
  analyticsTrackEvent(PARTICIPANT_HISTORY_OPENED, {
    itemType: ITEM_TYPE,
    spaceId,
  });
};
